import React, { useState, useEffect, createRef } from "react";
import styled from "styled-components";

const OTPInput = styled.input`
  width: 48px;
  gap: 10px;
  font-family: "DM Sans", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid
    ${(props) => (props.isError ? "rgba(241, 90, 97, 1)" : "#F5F5F5")};
  background: var(--Input-BG, #f5f5f5);
  text-align: center;
  padding: 16px 0px 16px 0px;
  @media (max-width: 991px) {
    width: 36px; // Change this to the width you want for mobile devices
    padding: 8px 0px 8px 0px;
  }
`;

const Countdown = styled.div`
  margin-top: 20px;
  margin-bottom: 16px;
`;

const TextStyle = styled.div`
  color: #838993;
  text-align: left;
  font-family: DM Sans, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

const ButtonComponent = styled.div`
  text-align: left;
  color: var(--Blue-Main-Purple, #7950ff);
  font-family: DM Sans, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  text-decoration: underline;
`;

const CodeWraper = styled.div`
  display: flex;
  gap: 8px;
  font-size: 24px;
  color: #0e0e0e;
  font-weight: 500;
  white-space: nowrap;
  line-height: 133%;
  align-items: flex-start;
  justify-content: flex-start;
`;

function OtpInput({ onResendCallBack, onCallBack, isError = false }) {
  const [OTP, setOTP] = useState(Array(6).fill(""));
  const [counter, setCounter] = useState(30);
  const [resendDisabled, setResendDisabled] = useState(true);

  const inputRefs = Array(6)
    .fill()
    .map(() => createRef());

  useEffect(() => {
    let timer;
    if (counter > 0 && resendDisabled) {
      timer = setTimeout(() => setCounter(counter - 1), 1000);
    } else if (counter === 0) {
      setResendDisabled(false);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [counter, resendDisabled]);

  const resendOTP = () => {
    // Resend OTP logic here
    setOTP(Array(4).fill(""));
    setCounter(30);
    setResendDisabled(true);
    onResendCallBack();
  };

  const handleOTPChange = (element, index) => {
    const newOTP = [
      ...OTP.map((d, i) => (i === index ? element.target.value : d)),
    ];
    setOTP(newOTP);
    if (element.target.nextSibling) {
      element.target.nextSibling.focus();
    }
    onCallBack(newOTP.join(""));
  };

  const handleKeyDown = (element, index) => {
    if (element.key === "Backspace" && !OTP[index] && inputRefs[index - 1]) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleKeyUp = (element, index) => {
    if (element.key === "Backspace" && !OTP[index] && inputRefs[index - 1]) {
      inputRefs[index - 1].current.focus();
    }
  };

  return (
    <div>
      <CodeWraper>
        {OTP.map((data, index) => {
          return (
            <OTPInput
              key={index}
              value={data}
              isError={isError}
              onChange={(e) => handleOTPChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onKeyUp={(e) => handleKeyUp(e, index)}
              maxLength="1"
              ref={inputRefs[index]}
            />
          );
        })}
      </CodeWraper>
      <Countdown>
        {resendDisabled ? (
          <TextStyle>{`Resend OTP in ${counter} seconds`}</TextStyle>
        ) : (
          <ButtonComponent onClick={resendOTP} disabled={resendDisabled}>
            Resend OTP
          </ButtonComponent>
        )}
      </Countdown>
    </div>
  );
}

export default OtpInput;